module.exports = __webpack_public_path__ + "img/va.6901bac3.png";